import React, { useEffect } from "react";
import SubscriptionPlan from "./components/SubscriptionPlan";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { getAllSubscription } from "../../../redux/action/subscription";
import PlanSkelton from "../../loader/PlanSkelton";

function SubcriptionPages() {
  const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 800px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const dispatch = useDispatch();
  const { subscriptionData, loadings } = useSelector(
    (pre) => pre?.allSubscriptionData
  );

  useEffect(() => {
    dispatch(getAllSubscription());
  }, [dispatch]);

  return (
    <div className="mt-1">
      <h4>Subscription</h4>

      <div className="cover white p-2 mt-1">
        <span className="valign-wrapper justify-center mr-2 font-25px bold gap-1">
          <h3 className="mb-2">Choose your right plan!</h3>
          <img
            style={{ marginTop: "-20px" }}
            width="45px"
            src="/images/subscriptionIcon.png"
            alt="subscriptionIcon"
          />
        </span>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "repeat(1,1fr)"
              : isTablet
              ? "repeat(2,1fr)"
              : isLaptop
              ? "repeat(3,1fr)"
              : "repeat(5, 1fr)",
            justifyContent: "center",
            columnGap: "1rem",
            rowGap: "2rem",
          }}
        >
          {loadings ? (
            <>
              {[...Array(5)].map((_, index) => (
                <PlanSkelton key={index} />
              ))}
            </>
          ) : (
            <>
              {subscriptionData?.map((items, index) => (
                <SubscriptionPlan
                  key={items?.price}
                  items={items}
                  recommended={items?.recommended}
                />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SubcriptionPages;
